<template>
  <div class="px-1 pt-0 text-center card-footer px-lg-2">
    <p class="mx-auto mb-4 text-sm">
      {{ data.paragraphText }}
      <a
        @click="data.buttonClick"
        style="cursor: pointer"
        class="text-success text-gradient font-weight-bold"
        >{{ data.buttonText }}</a
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "card-footer",
  props: {
    data: { type: Object },
  },
};
</script>